export const ticketUpdatedEvent = "ticketUpdated";
export const ticketsBulkUpdatedEvent = "ticketsBulkUpdated";
export const ticketDeletedEvent = "ticketDeleted";
export const ticketReadEvent = "ticketRead";
export const ticketToolsUpdatedEvent = "ticketToolsUpdated";
export const activeTicketContextEvent = "activeTicketContext";

export const dispatchTicketUpdated = ticket => {
  if (!ticket) return;
  window.dispatchEvent(
    new CustomEvent(ticketUpdatedEvent, {
      detail: { ticket },
    })
  );
};

export const dispatchTicketsBulkUpdated = tickets => {
  window.dispatchEvent(
    new CustomEvent(ticketsBulkUpdatedEvent, {
      detail: { tickets: Array.isArray(tickets) ? tickets : [] },
    })
  );
};

export const dispatchTicketDeleted = ticketId => {
  if (!ticketId) return;
  window.dispatchEvent(
    new CustomEvent(ticketDeletedEvent, {
      detail: { ticketId },
    })
  );
};

export const dispatchTicketRead = ({ ticket, ticketId }) => {
  const resolvedTicketId = ticketId || ticket?.id;
  if (!resolvedTicketId) return;
  window.dispatchEvent(
    new CustomEvent(ticketReadEvent, {
      detail: { ticket, ticketId: resolvedTicketId },
    })
  );
};

export const dispatchTicketToolsUpdated = ({ ticketId, tool, isActive }) => {
  if (!ticketId) return;
  window.dispatchEvent(
    new CustomEvent(ticketToolsUpdatedEvent, {
      detail: { ticketId, tool, isActive },
    })
  );
};

export const dispatchActiveTicketContext = context => {
  window.dispatchEvent(
    new CustomEvent(activeTicketContextEvent, {
      detail: { context: context || null },
    })
  );
};
